export default __webpack_public_path__ + "static/media/error.00b552a2.mp3";